import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive Spanish Ready™ after purchasing?',
  a: 'You will receive immediate access to all materials as soon as your payment is confirmed. No waiting. No shipping. Everything digital and ready to use within minutes.'
}, {
  q: 'What level is this designed for?',
  a: 'Spanish Ready™ covers beginner through early intermediate — Spanish 1 and Spanish 2 levels. Every activity includes differentiated versions for different ability levels within the same class.'
}, {
  q: 'Does it work for any English-speaking country?',
  a: 'Yes. Spanish Ready™ was designed specifically for Spanish teachers in English-speaking countries — including the United States, United Kingdom, Canada, Australia, and New Zealand.'
}, {
  q: 'Is the material editable?',
  a: 'The materials are provided in PDF format — professionally formatted, print-ready, and designed to be used immediately without editing.'
}, {
  q: 'What currency will I pay in?',
  a: 'You pay in your local currency. The checkout system automatically adapts to the country from which you are purchasing.'
}, {
  q: 'What if I do not like it?',
  a: "You have a complete 7-day money-back guarantee. If the material does not save you time, improve your students' engagement, or deliver the value we promise — you get every cent back. No questions asked."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-88">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-navy/10 rounded-xl overflow-hidden shadow-sm" data-id="element-90">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-91">
                <span className="font-bold text-lg text-navy pr-8" data-id="element-92">
                  {faq.q}
                </span>
                <ChevronDown className={`text-turquoise transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>

              <AnimatePresence data-id="element-94">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="px-6 pb-5 text-navy-light border-t border-navy/5 pt-4" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}